/* eslint react-hooks/exhaustive-deps: "warn" */

import { Button } from 'ui/atoms/Button/Button';
import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './KybApiBrowserCard.module.scss';

import type { KybApiBrowserCardProps } from './KybApiBrowserCard.types';

export const KybApiBrowserCard = ({ method, endpoint, title, description, dataReturned }: KybApiBrowserCardProps) => (
  <div className={styles.root}>
    <div className={styles.topBar}>
      <div className={styles.dots}>
        <span className={styles.dot} />
        <span className={styles.dot} />
        <span className={styles.dot} />
      </div>

      <div className={styles.urlBar}>
        <span className={styles.urlText}>www.api.globaldatabase.com</span>
      </div>

      <div className={styles.topBarActions}>
        <span className={styles.topBarBtn} />
        <span className={styles.topBarBtn} />
      </div>
    </div>

    <div className={styles.body}>
      <div className={styles.methodRow}>
        <span className={styles.methodBadge}>{method}</span>
        <span className={styles.endpoint}>{endpoint}</span>
      </div>

      <div className={styles.textBlock}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
      </div>

      {dataReturned && dataReturned.length > 0 && (
        <div className={styles.dataBox}>
          <p className={styles.dataLabel}>Data returned</p>

          <div className={styles.dataGrid}>
            {dataReturned.map((item) => (
              <div key={item} className={styles.dataItem}>
                <span className={styles.dataItemIcon}>
                  <Icon type="check-7" />
                </span>
                <span className={styles.dataItemText}>{item}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <Button route="/api" type="dark" size="xl">
        View Full API Documentation
      </Button>
    </div>
  </div>
);
